module.exports = __webpack_public_path__ + "static/media/c2-list.048ff45c.png";